import { render } from "./calendarManagement.vue?vue&type=template&id=f60295de&scoped=true"
import script from "./calendarManagement.vue?vue&type=script&lang=js"
export * from "./calendarManagement.vue?vue&type=script&lang=js"

import "./calendarManagement.vue?vue&type=style&index=0&id=f60295de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f60295de"]])

export default __exports__